import { URLS } from 'api/constants';
import { ICasinoReview, ICasinoReviewGraph } from 'constants/types';
import { useMutation } from 'hooks/useMutation';
import { useQuery } from 'hooks/useQuery';
import { apiGet, apiRequest } from 'lib/api/client';
import { PaginationResponse } from 'lib/api/types';
import { HookQueryOptions, queryKey } from './shared';

interface ListRequest {
  id: string;
  page?: number;
  limit?: number;
}

interface CreateCasinoReviewsRequest {
  casinoId: string;
  rating: number;
  review: string;
}

interface ToogleLikeRequest {
  reviewId: string;
}

export const useCasinoReviewsQuery = (
  payload: ListRequest,
  options?: HookQueryOptions
) =>
  useQuery<PaginationResponse<ICasinoReview>>(
    queryKey('casinoReviews.list', payload),
    () =>
      apiGet<PaginationResponse<ICasinoReview>>(
        `${URLS.CASINO_REVIEWS_BY_CASINO}${payload.id}`,
        { page: payload.page, limit: payload.limit }
      ),
    { skip: options?.skip || !payload?.id }
  );

export const useCasinoReviewsGraphQuery = (
  payload: { id: string },
  options?: HookQueryOptions
) =>
  useQuery<PaginationResponse<ICasinoReviewGraph>>(
    queryKey('casinoReviews.graph', payload),
    () =>
      apiGet<PaginationResponse<ICasinoReviewGraph>>(
        `${URLS.CASINO_REVIEWS_GRAPG_BY_CASINO}${payload.id}`
      ),
    { skip: options?.skip || !payload?.id }
  );

export const useCasinoReviewQuery = (
  payload: { id: string },
  options?: HookQueryOptions
) =>
  useQuery<ICasinoReview>(
    queryKey('casinoReviews.byId', payload),
    () => apiGet<ICasinoReview>(`${URLS.CASINO_REVIEWS}${payload.id}`),
    { skip: options?.skip || !payload?.id }
  );

export const useToogleLikeMutation = () =>
  useMutation<ToogleLikeRequest, void>(({ reviewId }) =>
    apiRequest<void>(URLS.CASINO_REVIEWS_LIKES, {
      method: 'POST',
      auth: true,
      body: { review_id: reviewId },
    })
  );

export const useToogleDislikeMutation = () =>
  useMutation<ToogleLikeRequest, void>(({ reviewId }) =>
    apiRequest<void>(URLS.CASINO_REVIEWS_DISLIKES, {
      method: 'POST',
      auth: true,
      body: { review_id: reviewId },
    })
  );

export const useCreateCasinoReviewsMutation = () =>
  useMutation<CreateCasinoReviewsRequest, void>(
    ({ casinoId, rating, review }) =>
      apiRequest<void>(URLS.CASINO_REVIEWS, {
        method: 'POST',
        auth: true,
        body: {
          casino_id: casinoId,
          rating,
          review,
        },
      })
  );

export const useUpdateCasinoReviewsMutation = () =>
  useMutation<CreateCasinoReviewsRequest, void>(
    ({ casinoId, rating, review }) =>
      apiRequest<void>(URLS.CASINO_REVIEWS_UPDATE, {
        method: 'POST',
        auth: true,
        body: {
          casino_id: casinoId,
          rating,
          review,
        },
      })
  );

export const useDeleteCasinoReviewsMutation = () =>
  useMutation<{ id: string }, void>(({ id }) =>
    apiRequest<void>(`${URLS.CASINO_REVIEWS}${id}`, {
      method: 'DELETE',
      auth: true,
    })
  );
